import { DO_ACTIONS } from "../../../actions/digitalOnboarding/types";

export const isDigitalOnboarding = action => (
    action.type.startsWith(DO_ACTIONS)
);